import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabButton", "additionalCard"]
  static values = { defaultTab: String }

  connect() {
    console.log("cards connect")

    if (this.defaultTabValue) {
      this.toggleCard({ params: { id: this.defaultTabValue } })
    }
  }

  toggleCard(event) {
    this.tabTargets.forEach(card => {
      if (card.id === event.params.id) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    this.tabButtonTargets.forEach(button => {
      if (button.dataset.cardsIdParam === event.params.id) {
        button.classList.add("font-medium", "border-blue-500", "text-blue-500")
        button.classList.remove("border-gray-200", "text-gray-400")
      } else {
        button.classList.remove("font-medium", "border-blue-500", "text-blue-500")
        button.classList.add("border-gray-200", "text-gray-400")
      }
    })

    // jak mamy część wspólną dla kilku kart, to dla części wspólnej dodajemy klasy
    // "additional_card_{id karty1} additional_card_{id karty2}"
    this.additionalCardTargets.forEach(card => {
      if (card.classList.contains(`additional_card_${event.params.id}`)) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  // toggle na podstawie wartości wybranej w selectcie
  toggleCardSelect(event) {
    const id = `select_card_${event.target.value}`

    event.params = { id }
    this.toggleCard(event)
  }
}

/*
Użycie:
  do zakładek które chcemy otwierać/zamykać należy dodać
  id="id_zakładki" data-cards-target="tab"

  a do przycisków otwierających/zamykających
  data-cards-id-param="zakładka która ma się otwierać" data-action="click->cards#toggleCard"

Działanie:
  kliknięce na przycisk otwierający jakąś zakładkę zamknie wszystkie pozostałe i zostawi otwartą tylko tę,
  na którą wskazuje data-cards-id-param z przycisku
*/
